import { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import { getAllMessagePositions, saveMessagePosition } from '@client/utility';

export const useMessagePositions = (chat_uuid: string) => {
  const [searchParams, setSearchParams] = useSearchParams();

  useEffect(() => {
    if (!chat_uuid) return;

    const loadPositions = async () => {
      try {
        const savedPositions = await getAllMessagePositions(chat_uuid);
        const newParams = new URLSearchParams(searchParams);
        let hasChanges = false;

        for (const [messageIdStr, position] of Object.entries(savedPositions)) {
          const messageId = parseInt(messageIdStr, 10);
          if (!isNaN(messageId) && position > 0) {
            const paramKey = `msg_${messageId}_alt`;
            if (!searchParams.get(paramKey)) {
              newParams.set(paramKey, position.toString());
              hasChanges = true;
            }
          }
        }

        if (hasChanges) {
          setSearchParams(newParams, { replace: true });
        }
      } catch (err) {
        console.error('Failed to load message positions:', err);
      }
    };

    loadPositions();
  }, [chat_uuid, setSearchParams]);

  useEffect(() => {
    if (!chat_uuid) return;

    const savePositions = async () => {
      try {
        const currentParams = new URLSearchParams(searchParams);
        for (const [key, value] of currentParams.entries()) {
          if (key.startsWith('msg_') && key.endsWith('_alt')) {
            const messageId = parseInt(
              key.replace('msg_', '').replace('_alt', ''),
              10
            );
            const position = parseInt(value, 10);
            if (!isNaN(messageId) && !isNaN(position)) {
              await saveMessagePosition(chat_uuid, messageId, position);
            }
          }
        }
      } catch (err) {
        console.error('Failed to save message positions:', err);
      }
    };

    savePositions();
  }, [searchParams, chat_uuid]);
};
